import {useEffect,useState} from 'react';
const descriptions=new Map<string,string>();
export function seedDescription(id:string,text:string){descriptions.set(id,text);}
function initialDescription(id:string){
 if(!descriptions.has(id)&&typeof document!=='undefined'){
  const source=document.getElementById('page-description');
  try{const entry=JSON.parse(source?.textContent??'null');if(entry?.id&&typeof entry.text==='string')descriptions.set(entry.id,entry.text);}catch{/* The route fetch below remains available. */}
 }
 return descriptions.get(id);
}
export function useDescription(id:string,fallback:string,updatedDescription?:string){
 const[value,setValue]=useState(()=>initialDescription(id)??fallback);
 useEffect(()=>{if(!id||descriptions.has(id))return;const controller=new AbortController();fetch('/data/descriptions/'+encodeURIComponent(id)+'.json',{signal:controller.signal}).then(r=>{if(!r.ok)throw new Error('Description unavailable');return r.json();}).then(text=>{if(typeof text==='string'){descriptions.set(id,text);setValue(text);}}).catch(()=>{/* Keep the summary available while offline. */});return()=>controller.abort();},[id]);
 return updatedDescription||value;
}
